import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidePage from "@/pages/guide/page";
import WhatIsVigorBuySpreadsheet from "@/pages/articles/what-is-vigorbuy-spreadsheet/page";
import VigorBuyVsExcel from "@/pages/articles/vigorbuy-vs-excel/page";
import FinancialSpreadsheetTemplates from "@/pages/articles/financial-spreadsheet-templates/page";
import InventoryManagementGuide from "@/pages/articles/inventory-management-guide/page";
import SalesTrackingGuide from "@/pages/articles/sales-tracking-guide/page";
import SmallBusinessSolutions from "@/pages/articles/small-business-solutions/page";
import SpreadsheetSecurityGuide from "@/pages/articles/spreadsheet-security-guide/page";
import EcommerceSpreadsheetTools from "@/pages/articles/ecommerce-spreadsheet-tools/page";
import ProjectManagementTips from "@/pages/articles/project-management-tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/what-is-vigorbuy-spreadsheet",
    element: <WhatIsVigorBuySpreadsheet />,
  },
  {
    path: "/vigorbuy-vs-excel",
    element: <VigorBuyVsExcel />,
  },
  {
    path: "/financial-spreadsheet-templates",
    element: <FinancialSpreadsheetTemplates />,
  },
  {
    path: "/inventory-management-guide",
    element: <InventoryManagementGuide />,
  },
  {
    path: "/sales-tracking-guide",
    element: <SalesTrackingGuide />,
  },
  {
    path: "/small-business-solutions",
    element: <SmallBusinessSolutions />,
  },
  {
    path: "/spreadsheet-security-guide",
    element: <SpreadsheetSecurityGuide />,
  },
  {
    path: "/ecommerce-spreadsheet-tools",
    element: <EcommerceSpreadsheetTools />,
  },
  {
    path: "/project-management-tips",
    element: <ProjectManagementTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;